import {createContext, type PropsWithChildren, use, useMemo, useState} from 'react'
import {useSearchParams} from '@github-ui/use-navigate'

interface PageContextType {
  page: number
  setPage: (page: number) => void
}

const PageContext = createContext<PageContextType | undefined>(undefined)

export function usePage() {
  const context = use(PageContext)
  if (!context) throw new Error('usePage must be used within a PageProvider')
  return context
}

export function PageProvider({children}: PropsWithChildren) {
  const [searchParams] = useSearchParams()
  const [page, setPage] = useState(() => (searchParams.has('page') ? Number(searchParams.get('page')) : 1))
  const value = useMemo(() => ({page, setPage}), [page, setPage])
  return <PageContext value={value}>{children}</PageContext>
}
